import React from "react";

export default function EventCardContainer(props) {
  const minute = 1000 * 60;
  const hour = minute * 60;
  const lastArrayItem = props.filteredEvents.length - 1;

  const totalEvents = props.filteredEvents.length;
  const firstEvent = props.filteredEvents[0].day;
  const lastEvent = props.filteredEvents[lastArrayItem].day;

  const minutesArr = props.filteredEvents.map((e) => {
    return e.totalMinutes;
  });

  const totalMinutesArr = minutesArr.reduce((a, b) => a + b, 0) * 60000;

  const totalHours = Math.floor(totalMinutesArr / hour);
  const totalMinutes = (totalMinutesArr / minute) % 60;

  return (
    <div className="bg-white shadow-md rounded-lg border max-w-md p-4 mb-4">
      <div className="flex-col justify-center bg-gray-200 rounded p-4">
        <h3 className="text-2xl leading-none font-bold text-primaryGreen text-center ">
          {totalEvents} Events with "{props.eventTitle}"
        </h3>
        <h3 className="text- leading-none text-secondaryGreen text-center mt-4 ">
          From: {firstEvent}
        </h3>
        <h3 className="text-sm leading-none text-secondaryGreen text-center mt-2">
          To: {lastEvent}
        </h3>
        <h3 className="text-xl font-bold leading-none text-fifthDarkOrange text-center mt-4">
          {totalHours}h {totalMinutes}m
        </h3>
      </div>

      <div className="flow-root">
        <ul className=" mt-4 divide-y divide-gray-200 dark:divide-gray-700">
          {props.filteredEvents.map((e, i) => {
            return (
              <li key={i} className="py-3 sm:py-4">
                <div className="flex items-center space-x-4">
                  <div className="flex-1 min-w-0">
                    <p className="text-sm font-medium text-primaryGreen truncate dark:text-white">
                      {e.title}
                    </p>
                    <p className="text-sm text-fourthOrange truncate dark:text-gray-400">
                      {e.day} @ {e.startTime}
                    </p>
                  </div>
                  <div className="inline-flex items-center text-base font-semibold text-fifthDarkOrange dark:text-white">
                    {e.hours}h {e.minutes}m
                  </div>
                </div>
              </li>
            );
          })}
          <li className="py-1">
            <div className="flex items-center space-x-4"></div>
          </li>
        </ul>
      </div>
    </div>
  );
}
